module.exports = __webpack_public_path__ + "img/position.38ac06fd.svg";